if (!customElements.get('lets-get-real-earth')) {
  customElements.define('lets-get-real-earth', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.tick = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const rect = this.getBoundingClientRect();
          const progress = Math.min(1, Math.max(0, (innerHeight - rect.top) / (innerHeight + rect.height)));
          this.style.setProperty('--e', this.motion.matches ? .5 : progress.toFixed(3));
        });
      };
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.add('is-in');
          this.observer.disconnect();
        }
      }, { threshold: .15 });
      this.observer.observe(this);
      window.addEventListener('scroll', this.tick, { passive: true, signal });
      window.addEventListener('resize', this.tick, { signal });
      this.motion.addEventListener('change', this.tick, { signal });
      this.tick();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.classList.remove('is-in');
    }
  });
}